import { render, staticRenderFns } from "./WhyUsSection.vue?vue&type=template&id=2d6102d2&scoped=true&"
import script from "./WhyUsSection.vue?vue&type=script&lang=js&"
export * from "./WhyUsSection.vue?vue&type=script&lang=js&"
import style0 from "./WhyUsSection.vue?vue&type=style&index=0&id=2d6102d2&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6102d2",
  null
  
)

export default component.exports